module.exports = __webpack_public_path__ + "2eb91732efea146cb041ad3cd7814f34.png";